import React, { type FC } from 'react';
import { Image } from '@wix/design-system';
import css from './markdowns.scss';
import classNames from 'classnames';
import { DataHooks } from '../../constants/dataHooks';

export const imageSizes = ['L', 'M', 'S'] as const;

type Props = {
  src: string;
  alt?: string;
  className?: (typeof imageSizes)[number];
};

export const ImageMarkdown: FC<Props> = ({
  src,
  alt,
  children,
  className = 'L',
}) => {
  let size = 'L';
  if (imageSizes.includes(className)) {
    size = className;
  }

  return (
    <Image
      key={src}
      dataHook={DataHooks.ImageMarkDown}
      src={src}
      alt={alt}
      fit="contain"
      className={classNames(css.image, css[size])}
    >
      {children}
    </Image>
  );
};
